export interface Complaint {
  listingId: string;
  reason: string;
  comment?: string;
  timestamp: number;
  userId: string;
}

export const MOCK_COMPLAINTS: Complaint[] = [];
